import {createAction} from "redux-act";
import {IRound} from "modules/types/json";

export const fetchRounds = createAction();
export const fetchRoundsDelayed = createAction();
export const fetchRoundsSuccess = createAction<IRound[]>();

export const selectRound = createAction<number | undefined>();
